// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5794":"adaptiveDrawers-AdaptiveDrawers","8203":"adaptiveDrawers-App","8665":"adaptiveDrawers-adaptiveDrawersStyles-scss"}[chunkId] + ".css";
};